import React, { FC, memo } from 'react';
import dayjs from 'dayjs';

import usePrefix from 'utils/usePrefix';
import Modal from 'components/Modal';
import { RatingEntryResponse } from 'utils/api/notice';

import { RatingHistoryTableStyled } from './styles';
import { COMMENT_CELL_CLASS, SINGLE_LINE_CLASS } from './constants';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  ratings: RatingEntryResponse[];
}

const RatingHistoryModal: FC<Props> = ({ isOpen, onClose, ratings }) => {
  const t = usePrefix('Rating');

  return (
    <Modal isOpen={isOpen} onClose={onClose} centered>
      <h3>{t('rating_history')}</h3>
      {ratings.length > 0 ? (
        <RatingHistoryTableStyled>
          <table>
            <thead>
              <tr>
                <th>{t('col_date')}</th>
                <th>{t('col_updated')}</th>
                <th>{t('col_rating')}</th>
                <th>{t('col_text')}</th>
                <th>{t('col_user_name')}</th>
              </tr>
            </thead>
            <tbody>
              {ratings.map((entry, idx) => (
                <tr key={idx}>
                  <td className={SINGLE_LINE_CLASS}>
                    {dayjs(entry.created_at).format('DD-MM-YYYY')}
                  </td>
                  <td className={SINGLE_LINE_CLASS}>
                    {dayjs(entry.updated_at).format('DD-MM-YYYY')}
                  </td>
                  <td>{entry.stars}</td>
                  <td className={COMMENT_CELL_CLASS}>
                    {entry.comment ? <p>{entry.comment}</p> : null}
                  </td>
                  <td>{`${entry.user_name} (${entry.user_email})`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </RatingHistoryTableStyled>
      ) : (
        t('no_ratings')
      )}
    </Modal>
  );
};

export default memo(RatingHistoryModal);
